module.exports = __webpack_public_path__ + "assets/img/bottom.dace2e75.png";